import { IOnInit } from "angular";

export class ContractInstanceNumbersComponentController implements IOnInit {
  static $inject = [];
  constructor() {}

  $onInit() {}
}
